import React, { useState } from 'react';
import './DriverCTA.css';

const perks = [
  {
    emoji: '\u{1F4B0}',
    title: 'Higher earnings',
    description: 'We fill your return trips. Earn 15\u201330% more per month than going solo.',
  },
  {
    emoji: '\u{1F4C5}',
    title: 'You choose your hours',
    description: 'Work when you want. No daily targets. No pressure. Total flexibility.',
  },
  {
    emoji: '\u{1F3C6}',
    title: 'Weekly UPI payments',
    description: 'Earnings straight to your bank every Sunday. Always on time.',
  },
];

const DriverCTA = () => {
  const [form, setForm] = useState({
    name: '',
    phone: '',
    vehicleType: '',
    city: '',
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission
    console.log('Driver registration:', form);
  };

  return (
    <section className="driver-cta">
      <div className="driver-cta__container">
        {/* Left — Text + Perks */}
        <div className="driver-cta__left">
          <span className="driver-cta__eyebrow">Join our fleet</span>
          <h2 className="driver-cta__heading">
            Drive with ZilaCab.<br />Earn more.
          </h2>
          <p className="driver-cta__body">
            Join Bihar&rsquo;s fastest growing cab network. We connect you with passengers across
            38 districts so you spend less time waiting and more time earning.
          </p>

          <div className="driver-cta__perks">
            {perks.map((perk, index) => (
              <div key={index} className="driver-cta__perk">
                <div className="driver-cta__perk-icon">
                  <span>{perk.emoji}</span>
                </div>
                <div className="driver-cta__perk-text">
                  <h5 className="driver-cta__perk-title">{perk.title}</h5>
                  <p className="driver-cta__perk-desc">{perk.description}</p>
                </div>
              </div>
            ))}
          </div>

          <a href="#register-driver" className="driver-cta__btn">
            Register as driver &rarr;
          </a>
        </div>

        {/* Right — Registration Form */}
        <div className="driver-cta__right">
          <div className="driver-cta__form-card">
            <h3 className="driver-cta__form-title">Register as a driver partner</h3>
            <form className="driver-cta__form" onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Full name"
                value={form.name}
                onChange={handleChange}
                className="driver-cta__input"
                required
              />
              <input
                type="tel"
                name="phone"
                placeholder="Phone number"
                value={form.phone}
                onChange={handleChange}
                className="driver-cta__input"
                required
              />
              <select
                name="vehicleType"
                value={form.vehicleType}
                onChange={handleChange}
                className="driver-cta__input driver-cta__select"
                required
              >
                <option value="" disabled>Vehicle type</option>
                <option value="sedan">Sedan</option>
                <option value="suv">SUV</option>
                <option value="tempo-traveller">Tempo Traveller</option>
                <option value="mini-truck">Mini Truck</option>
                <option value="auto-rickshaw">Auto Rickshaw</option>
              </select>
              <input
                type="text"
                name="city"
                placeholder="Base city"
                value={form.city}
                onChange={handleChange}
                className="driver-cta__input"
                required
              />
              <button type="submit" className="driver-cta__submit">
                Join as driver partner &rarr;
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DriverCTA;
